export default __webpack_public_path__ + "static/media/260.c9b5435b.jpg";